import { getPersonBankAccounts } from '@dealstack/frontend/app/services/Person.service.ts';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { deletePersonBankAccountRequest } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/apis/useBankAccounts.ts';
import type { BankAccountDetails } from '@dealstack/frontend/shared/components/BankAccountForm/types.ts';

export const useBankAccounts = () => {
	const { selectedEntityId } = useContext(CapManageControllerContext);
	const [addBankAccount, setAddBankAccount] = useState<boolean>(false);
	const [editBankAccount, setEditBankAccount] = useState<BankAccountDetails | null>(null);
	const [deleteBankAccount, setDeleteBankAccount] = useState<BankAccountDetails | null>(null);

	const {
		data: bankAccounts,
		isFetching: bankAccountsFetching,
		refetch: refetchBankAccounts,
	} = useQuery({
		queryKey: ['bankAccounts', selectedEntityId],
		queryFn: () => getPersonBankAccounts(selectedEntityId),
		enabled: !!selectedEntityId,
	});

	const deletePersonBankAccountMutation = useMutation({
		mutationFn: deletePersonBankAccountRequest,
	});

	const deletePersonBankAccount = () => {
		if (!deleteBankAccount) {
			return;
		}

		deletePersonBankAccountMutation.mutate(
			{
				personId: selectedEntityId,
				bankAccountId: deleteBankAccount.id,
			},
			{
				onSuccess: () => {
					void refetchBankAccounts();
					setDeleteBankAccount(null);
				},
			}
		);
	};

	return {
		bankAccounts: bankAccounts ?? [],
		isBankAccountsLoading: bankAccountsFetching,
		refetchBankAccounts,
		deletePersonBankAccount,
		deleteBankAccount,
		setDeleteBankAccount,
		editBankAccount,
		setEditBankAccount,
		addBankAccount,
		setAddBankAccount,
		deletePersonBankAccountLoading: deletePersonBankAccountMutation.isPending,
		deletePersonBankAccountSuccess: deletePersonBankAccountMutation.isSuccess,
	};
};
